/**
 * Labstep
 *
 * @module components/Entity/Action/Create/Templatable
 * @desc Create Action for Templatable entities
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { CanCreate } from 'labstep-web/components/Entity/Can';
import EntityFormCreateTemplatable from 'labstep-web/components/Entity/Form/Create/Templatable';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type { APIResponse } from 'labstep-web/models';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { EntityActionCreateTemplatableProps } from './types';

export const EntityActionCreateTemplatable: React.FC<
  EntityActionCreateTemplatableProps
> = ({
  entityName,
  templateId,
  history,
  withRedirect = true,
  withName = false,
  actionComponentProps,
}) => {
  const text = `New ${getHumanReadableEntityName(
    entityName,
    false,
    true,
  )}`;

  if (templateId) {
    return (
      <EntityActionCreate
        entityName={entityName}
        actionComponentProps={actionComponentProps}
        body={{ template_id: templateId }}
      />
    );
  }

  return (
    <ModalDefault
      header={text}
      content={({ toggleModal }): React.ReactElement => (
        <EntityFormCreateTemplatable
          entityName={entityName}
          templateId={templateId}
          withName={withName}
          showLoaderWhileCreating
          options={{
            onSuccess: ({
              response,
            }: {
              response: APIResponse;
            }): void => {
              toggleModal();
              if (withRedirect) {
                history.push(
                  navigation.get(`${entityName}_show`, {
                    id: response.result,
                  }),
                );
              }
            },
          }}
        />
      )}
      viewComponent={({ toggleModal }): React.ReactElement => {
        if (actionComponentProps?.type) {
          return (
            <CanCreate entityName={entityName}>
              <ActionComponent
                text={text}
                {...actionComponentProps}
                onClick={toggleModal}
              />
            </CanCreate>
          );
        }
        return (
          <CanCreate entityName={entityName}>
            <ActionComponent
              type="button"
              text={text}
              onClick={toggleModal}
            />
          </CanCreate>
        );
      }}
    />
  );
};

export default withRouter(EntityActionCreateTemplatable);
